module.exports = __webpack_public_path__ + "img/mycb02.b223071d.png";